import { Stack } from '@mantine/core'
import { AnyRouter, createFileRoute } from '@tanstack/react-router'
import GroupedShortageTable from 'components/shortage/GroupedShortageTable'
import ShortageTable from 'components/shortage/ShortageTable'
import { usersQuery } from 'hooks/users'
import { useState } from 'react'
import { Account } from 'types/auth'

export const Route = createFileRoute('/_auth/_admin/shortages/')({
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(usersQuery)
  },
  component: RouteComponent,
})

function RouteComponent() {
  const users = Route.useLoaderData<AnyRouter, Array<Account>>()
  const [isGrouped, setIsGrouped] = useState(false)

  return (
    <Stack mt="xl">
      {isGrouped ? (
        <GroupedShortageTable users={users} ungroup={() => setIsGrouped(false)} />
      ) : (
        <ShortageTable users={users} group={() => setIsGrouped(true)} />
      )}
    </Stack>
  )
}
